import { onServerPrefetch, type Ref } from 'vue';
import { useStore } from 'vuex';

type AwardId = number | string;

export function useAwards(listAwards: Ref<AwardId[]>) {
    const store = useStore();

    onServerPrefetch(async () => {
        if (!listAwards.value?.length) return;
        const promises = listAwards.value.map((id) => store.dispatch('awards/getAward', id));
        await Promise.all(promises);
    });
}
